import { ClerkProvider } from '@clerk/react';
import { Outlet, useNavigate } from 'react-router';

import { AuthBridge } from '@/features/auth/auth-bridge';

const publishableKey = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY as string | undefined;

/**
 * The root route. ClerkProvider lives inside the router so Clerk navigates with
 * React Router instead of full page loads.
 */
export function RootLayout() {
  const navigate = useNavigate();

  if (!publishableKey) {
    throw new Error(
      'VITE_CLERK_PUBLISHABLE_KEY is not set. Copy apps/web/.env.example to apps/web/.env and add the key from the Clerk dashboard.',
    );
  }

  return (
    <ClerkProvider
      publishableKey={publishableKey}
      routerPush={(to) => navigate(to)}
      routerReplace={(to) => navigate(to, { replace: true })}
      signInUrl="/sign-in"
      signUpUrl="/sign-up"
      afterSignOutUrl="/sign-in"
    >
      <AuthBridge />
      <Outlet />
    </ClerkProvider>
  );
}
